// extracted by mini-css-extract-plugin
module.exports = {"summaryRow":"exemptionSummary_summaryRow__2eEXj","label":"exemptionSummary_label__4cANx","action":"exemptionSummary_action__3YWDG","noBorder":"exemptionSummary_noBorder__1FDUM"};